import type { ICamera } from '@api/models/camera.model';
import type { ICameraCCTV } from '@api/models/camera-cctv.model';
import { TMapCamera } from '@api/types/camera-map.type';
export const toMapCameraFromTimelapse = (camera: ICamera): TMapCamera => ({
    name: camera.name,
    location: camera.location,
    latestImage: camera.latestImage,
});

export const toMapCameraFromCctv = (camera: ICameraCCTV): TMapCamera => ({
    name: camera.name,
    location: camera.location,
    latestImage: camera.latestImage,
});
